<template>
<div>
  <ItpButton
    :text="text"
    :icon="icon"
    :variant="variant"
    :spinning="spinning"
    :disabled="disabled"
    :size="size"
    :tooltip="tooltip"
    :block="block"
    class="app-JobHandlerControl"
    v-if="loaded && !jobData"
    @click.prevent.stop="evh_7315092382398562_clickPreventStop($event, {})"
  >
  </ItpButton>
  <div
    class="input-group app-JobHandlerControl"
  >
    <b-dropdown
      split
      :size="size"
      :title="tooltip"
      :variant="variant"
      :disabled="jobData ? false : disabled"
      split-class="border"
      toggle-class="border"
      v-if="loaded && jobData"
      @click.prevent.stop="evh_96700093353179_clickPreventStop($event, {})"
      @bv::dropdown::hide="evh_96700093353179_bvDropdownHide($event, {})"
      @bv::dropdown::show="evh_96700093353179_bvDropdownShow($event, {})"
    >
      <template
        slot="button-content"
      >
        <ItpBox
          alignItems="center"
        >
          <b-spinner
            small
            type="grow"
            class="mr-1"
            v-if="spinning"
          >
          </b-spinner>
          <ItpIcon
            :name="icon"
            class="mr-1"
            v-if="icon"
          >
          </ItpIcon>
          <span
            class="text-nowrap"
            v-if="text"
          >
            {{ text }}
          </span>
          <UcStatusBadge
            :status="status"
            class="ml-2"
            v-if="status"
          >
          </UcStatusBadge>
        </ItpBox>
      </template>
      <b-dropdown-item
        @click.prevent.stop="evh_302930856768608_clickPreventStop($event, {})"
      >
        {{ messages.showJobTooltip }}...
      </b-dropdown-item>
      <b-dropdown-item
        @click.prevent.stop="evh_939987670462915_clickPreventStop($event, {})"
      >
        {{ messages.reloadJobData }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class JobHandlerControl extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getPoller(...args: any[]) {
    if (!this._poller) {
      this._poller = this.$fn.poller({
        id: 'Job',
        callback: this.checkJob.bind(this),
        interval: this.pollingInterval,
      });
    }
    return this._poller
  }

  beforeDestroy(...args: any[]) {
    { { this._poller && this._poller.stop() } }
  }

  checkJob(...args: any[]) {
    if (!this.jobData) {
      return false;
    }

    const status = this.status;

    if (status && this.status != status) {
      // status change
      console.log(`checkJob: jobStatus changed from ${this.status} to ${status}`, this.jobPoller);
      this.$emit(status);
      this.status = status;
    }

    if (status !== 'pending' && status !== 'running') {
      console.log(`checkJob: JobStatus is ${status}, stop polling.`, this.jobPoller);
      this.jobPoller.stop();
      this.$emit('success');
      return;
    }

    console.log('checkJob: fetch', this.jobPoller);

    return this.$fn
      .fetch('read_job_info', { parameters: { id: this.jobData.id } })
      .then(data => { this.onJobInfoReceived(data) });
  }

  loadJob(...args: any[]) {
    return this.$fn
      .fetch('read_a_job', { parameters: { id: this.jobData.id } })
      .then(data => this.onJobReceived(data))
      .then(() => this.maybeStopPoll())
      .catch(error => this.handleError(error))
  }

  onJobInfoReceived(...args: any[]) {
    const [{ status, progress }] = args;

    this.progress = progress

    if (status && this.status != status) {
      this.setData('status', status);
      this.$emit(status);

      if (status === 'completed') {
        this.$emit('success');
      }

      if (status !== 'running') {
        return this.loadJob();
      }
    }
  }

  onJobReceived(...args: any[]) {
    const [resource] = args;
    this.setData('jobData', resource);
    this.setData('status', resource.status);
    this.setData('progress', resource.progress);
  }

  onSubmit(...args: any[]) {
    const val = _.isFunction(this.payload) ? this.payload() : this.payload;

    if (this.isRunning) {
      return;
    }

    Promise
      .resolve(val)
      .then(payload => {

        if (!payload || payload.cancel) {
          return;
        }

        this.$fn.crud('a_job')
          .create(payload, { parameters: { job_type: this.jobType } })
          .then(resource => this.onJobReceived(resource))
          .then(() => this.maybeStartPoll())
          .catch(error => this.handleError(error))
      })
      .catch(error => this.handleError(error))
  }

  maybeStartPoll(...args: any[]) {
    if (['completed', 'failed', 'cancelled', 'deleted'].indexOf(this.status) > -1) {
      return;
    }

    if (!this.jobPoller.isRunning) {
      return this.jobPoller.start()
    }
  }

  maybeStopPoll(...args: any[]) {
    if (['pending', 'running'].indexOf(this.status) > -1) {
      return;
    }

    if (this.jobPoller.isRunning) {
      return this.jobPoller.stop()
      if (this.status == 'completed') {
        this.$emit('success');
      }
    }
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  block!: boolean;

  @Watch('block')
  onBlock(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("block")
  }

  @Prop({
    required: true,
    type: String,
  })
  jobType!: string;

  @Watch('jobType')
  onJob_type(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("jobType")
  }

  @Prop({
    required: true,
    type: String,
  })
  text!: string;

  @Watch('text')
  onText(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("text")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  loadCurrent!: boolean;

  @Watch('loadCurrent')
  onLoad_current(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("loadCurrent")
  }

  @Prop({
    required: true,
  })
  payload!: Function;

  @Watch('payload')
  onPayload(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("payload")
  }

  @Prop({
    type: String,
  })
  jobId!: string;

  @Watch('jobId')
  onJob_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("jobId")
  }

  @Prop({
    type: String,
  })
  icon!: string;

  @Watch('icon')
  onIcon(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("icon")
  }

  @Prop({
    type: String,
    default: "light",
  })
  variant!: string;

  @Watch('variant')
  onVariant(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("variant")
  }

  @Prop({
    type: Boolean,
  })
  disabled!: boolean;

  @Watch('disabled')
  onDisabled(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("disabled")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  @Prop({
    type: String,
  })
  tooltip!: string;

  @Watch('tooltip')
  onTooltip(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("tooltip")
  }

  @Prop({
    type: Number,
    default: 1000,
  })
  pollingInterval!: number;

  @Watch('pollingInterval')
  onPolling_interval(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("pollingInterval")
  }

  messages!: any;
  jobData!: any;

  async $$load_jobData() {
    return this.loadCurrent
      ? this.$fn.fetch('read_a_job', { parameters: { id: this.jobID || 'current', job_type: this.jobType }, asResource: true })
      : null
  }

  jobPoller!: any;

  async $$load_jobPoller() {
    return this.getPoller()
  }

  status!: any;
  progress!: any;
  ux!: any;
  dataMembers = ['messages', 'jobData', 'jobPoller', 'status', 'progress', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          showJobTooltip: this.$fn.pgettext("JobHandler|Command", "Open job details"),
          reloadJobData: this.$fn.pgettext("JobHandler|Command", "Reload job status"),
        }
        ,
        jobData: null,
        jobPoller: null,
        status: null,
        progress: null,
        ux: null,
      },
    }
  }

  get isRunning() {
    if (this.loaded) {

      return this.status === 'running'
    }
    return null;
  }

  get isPending() {
    if (this.loaded) {

      return this.status === 'pending'
    }
    return null;
  }

  get spinning() {
    if (this.loaded) {

      return this.isRunning || this.isPending || (this.actions && this.actions.reloadJobData && this.actions.reloadJobData.isRunning)
    }
    return null;
  }

  async act_7315092382398562_script_7574_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7315092382398562_script_7574, alias=submit
    this.onSubmit()
  }

  async act_7315092382398562_script_7574_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_7574, alias=submit
    return {
      value: () => this.act_7315092382398562_script_7574_getActionArgs_value($event),
    }
  }

  async act_7315092382398562_script_7574_getWhen($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_7574, alias=submit
    return !this.disabled
  }

  async evh_7315092382398562_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_96700093353179_script_7576_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_96700093353179_script_7576, alias=submit
    this.onSubmit()
  }

  async act_96700093353179_script_7576_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_96700093353179_script_7576, alias=submit
    return {
      value: () => this.act_96700093353179_script_7576_getActionArgs_value($event),
    }
  }

  async act_96700093353179_script_7576_getWhen($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_96700093353179_script_7576, alias=submit
    return !this.disabled
  }

  async evh_96700093353179_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_96700093353179_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_96700093353179_script_7578_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_96700093353179_script_7578, alias=undefined
    $event.stop()
  }

  async act_96700093353179_script_7578_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_96700093353179_script_7578, alias=undefined
    return {
      value: () => this.act_96700093353179_script_7578_getActionArgs_value($event),
    }
  }

  async evh_96700093353179_bvDropdownHide(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_96700093353179_bvDropdownHide.executeFromDOM(this, event, scope);
  }

  async act_96700093353179_script_7580_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_96700093353179_script_7580, alias=undefined
    console.log($event)
  }

  async act_96700093353179_script_7580_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_96700093353179_script_7580, alias=undefined
    return {
      value: () => this.act_96700093353179_script_7580_getActionArgs_value($event),
    }
  }

  async evh_96700093353179_bvDropdownShow(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_96700093353179_bvDropdownShow.executeFromDOM(this, event, scope);
  }

  async act_302930856768608_showModal_7582_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_302930856768608_showModal_7582, alias=showJob
    return {
      name: "Job",
      props: {
        oid: this.jobData.id,
      }
      ,
    }
  }

  async evh_302930856768608_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_302930856768608_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_939987670462915_setData_7586_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_939987670462915_setData_7586, alias=undefined
    return {
      path: "jobData",
      value: $event.data.response.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_939987670462915_setData_7586_getWhen($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_939987670462915_setData_7586, alias=undefined
    return $event.data.response.data
  }

  async act_939987670462915_request_7584_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_939987670462915_request_7584, alias=reloadJobData
    return {
      operation: "read_a_job",
      parameters: {
        id: this.jobData.id,
      }
      ,
    }
  }

  async evh_939987670462915_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_939987670462915_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_script_7574: actions.ScriptAction;
    evh_7315092382398562_clickPreventStop_7573: actions.EventHandlerImpl;
    evh_7315092382398562_clickPreventStop: actions.EventHandlerGroup;
    act_96700093353179_script_7576: actions.ScriptAction;
    evh_96700093353179_clickPreventStop_7575: actions.EventHandlerImpl;
    evh_96700093353179_clickPreventStop: actions.EventHandlerGroup;
    act_96700093353179_script_7578: actions.ScriptAction;
    evh_96700093353179_bvDropdownHide_7577: actions.EventHandlerImpl;
    evh_96700093353179_bvDropdownHide: actions.EventHandlerGroup;
    act_96700093353179_script_7580: actions.ScriptAction;
    evh_96700093353179_bvDropdownShow_7579: actions.EventHandlerImpl;
    evh_96700093353179_bvDropdownShow: actions.EventHandlerGroup;
    act_302930856768608_showModal_7582: actions.ShowModalAction;
    evh_302930856768608_clickPreventStop_7581: actions.EventHandlerImpl;
    evh_302930856768608_clickPreventStop: actions.EventHandlerGroup;
    act_939987670462915_setData_7586: actions.SetDataAction;
    evh_939987670462915_success_7585: actions.EventHandlerImpl;
    act_939987670462915_request_7584: actions.RequestAction;
    evh_939987670462915_clickPreventStop_7583: actions.EventHandlerImpl;
    evh_939987670462915_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_script_7574 = new actions.ScriptAction(
      {
        actionArgs: this.act_7315092382398562_script_7574_getActionArgs,
        when: this.act_7315092382398562_script_7574_getWhen,
        displayName: "submit",
        events: [],
      }
    );
    const evh_7315092382398562_clickPreventStop_7573 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_script_7574,
        event: "click.prevent.stop",
        displayName: "submit",
      }
    );
    const evh_7315092382398562_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_clickPreventStop_7573],
      }
    );
    const act_96700093353179_script_7576 = new actions.ScriptAction(
      {
        actionArgs: this.act_96700093353179_script_7576_getActionArgs,
        when: this.act_96700093353179_script_7576_getWhen,
        displayName: "submit",
        events: [],
      }
    );
    const evh_96700093353179_clickPreventStop_7575 = new actions.EventHandlerImpl(
      {
        action: act_96700093353179_script_7576,
        event: "click.prevent.stop",
        displayName: "submit",
      }
    );
    const evh_96700093353179_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_96700093353179_clickPreventStop_7575],
      }
    );
    const act_96700093353179_script_7578 = new actions.ScriptAction(
      {
        actionArgs: this.act_96700093353179_script_7578_getActionArgs,
        events: [],
      }
    );
    const evh_96700093353179_bvDropdownHide_7577 = new actions.EventHandlerImpl(
      {
        action: act_96700093353179_script_7578,
        event: "bv::dropdown::hide",
        displayName: "script",
      }
    );
    const evh_96700093353179_bvDropdownHide = new actions.EventHandlerGroup(
      {
        handlers: [evh_96700093353179_bvDropdownHide_7577],
      }
    );
    const act_96700093353179_script_7580 = new actions.ScriptAction(
      {
        actionArgs: this.act_96700093353179_script_7580_getActionArgs,
        events: [],
      }
    );
    const evh_96700093353179_bvDropdownShow_7579 = new actions.EventHandlerImpl(
      {
        action: act_96700093353179_script_7580,
        event: "bv::dropdown::show",
        displayName: "script",
      }
    );
    const evh_96700093353179_bvDropdownShow = new actions.EventHandlerGroup(
      {
        handlers: [evh_96700093353179_bvDropdownShow_7579],
      }
    );
    const act_302930856768608_showModal_7582 = new actions.ShowModalAction(
      {
        actionArgs: this.act_302930856768608_showModal_7582_getActionArgs,
        displayName: "showJob",
        events: [],
      }
    );
    const evh_302930856768608_clickPreventStop_7581 = new actions.EventHandlerImpl(
      {
        action: act_302930856768608_showModal_7582,
        event: "click.prevent.stop",
        displayName: "showJob",
      }
    );
    const evh_302930856768608_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_302930856768608_clickPreventStop_7581],
      }
    );
    const act_939987670462915_setData_7586 = new actions.SetDataAction(
      {
        actionArgs: this.act_939987670462915_setData_7586_getActionArgs,
        when: this.act_939987670462915_setData_7586_getWhen,
        events: [],
      }
    );
    const evh_939987670462915_success_7585 = new actions.EventHandlerImpl(
      {
        action: act_939987670462915_setData_7586,
        event: "success",
        displayName: "setData",
      }
    );
    const act_939987670462915_request_7584 = new actions.RequestAction(
      {
        actionArgs: this.act_939987670462915_request_7584_getActionArgs,
        displayName: "reloadJobData",
        events: [evh_939987670462915_success_7585],
      }
    );
    const evh_939987670462915_clickPreventStop_7583 = new actions.EventHandlerImpl(
      {
        action: act_939987670462915_request_7584,
        event: "click.prevent.stop",
        displayName: "reloadJobData",
      }
    );
    const evh_939987670462915_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_939987670462915_clickPreventStop_7583],
      }
    );
    return {
      act_7315092382398562_script_7574,
      evh_7315092382398562_clickPreventStop_7573,
      evh_7315092382398562_clickPreventStop,
      act_96700093353179_script_7576,
      evh_96700093353179_clickPreventStop_7575,
      evh_96700093353179_clickPreventStop,
      act_96700093353179_script_7578,
      evh_96700093353179_bvDropdownHide_7577,
      evh_96700093353179_bvDropdownHide,
      act_96700093353179_script_7580,
      evh_96700093353179_bvDropdownShow_7579,
      evh_96700093353179_bvDropdownShow,
      act_302930856768608_showModal_7582,
      evh_302930856768608_clickPreventStop_7581,
      evh_302930856768608_clickPreventStop,
      act_939987670462915_setData_7586,
      evh_939987670462915_success_7585,
      act_939987670462915_request_7584,
      evh_939987670462915_clickPreventStop_7583,
      evh_939987670462915_clickPreventStop,
      submit: act_96700093353179_script_7576,
      showJob: act_302930856768608_showModal_7582,
      reloadJobData: act_939987670462915_request_7584,
    }
  }
}

Vue.component("JobHandlerControl", JobHandlerControl);

</script>